if (!customElements.get('grid-3x2')) {
  customElements.define('grid-3x2', class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.loadData();
    }
    async loadData() {
      const url = this.getAttribute('data-asset-url');
      if (!url) return;
      try {
        const response = await fetch(url);
        const data = await response.json();
        this.render(data);
      } catch (e) {
        console.error('Failed to load grid data:', e);
      }
    }
    render(items) {
      const container = this.querySelector('.grid-3x2__container');
      const root = this.getAttribute('data-asset-root') || '';
      if (!container) return;
      container.innerHTML = '';
      container.classList.remove('loading');
      items.slice(0, 6).forEach(item => {
        const anchor = document.createElement('a');
        anchor.className = 'grid-3x2__item';
        anchor.href = item.link || '#';
        if (item.icon) {
          const img = document.createElement('img');
          // Resolve relative path if icon is just a filename
          img.src = item.icon.includes('://') ? item.icon : root + item.icon;
          img.className = 'grid-3x2__icon';
          img.alt = item.text;
          img.loading = 'lazy';
          anchor.appendChild(img);
        }
        const span = document.createElement('span');
        span.className = 'grid-3x2__text';
        span.textContent = item.text;
        anchor.appendChild(span);
        container.appendChild(anchor);
      });
    }
  });
}
